import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getConversaciones } from '../../services/conversacionesService.js';

const CANAL_LABEL = {
  whatsapp: '💬 WhatsApp',
  email: '📧 Email',
  sms: '📱 SMS',
  apns: '🍎 Push',
};

const TABS = [
  { canal: 'whatsapp', label: '💬 WhatsApp' },
  { canal: 'email', label: '📧 Email' },
];

export default function ConversacionesList() {
  const [canal, setCanal] = useState('whatsapp');
  const [conversaciones, setConversaciones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    setError(null);
    getConversaciones(canal)
      .then(setConversaciones)
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, [canal]);

  return (
    <div style={{ padding: 24, maxWidth: 700 }}>
      <h2>Conversaciones</h2>

      <div style={{ display: 'flex', gap: 8, marginBottom: 16, borderBottom: '1px solid #e0e0e0' }}>
        {TABS.map((t) => {
          const active = t.canal === canal;
          return (
            <button
              key={t.canal}
              onClick={() => setCanal(t.canal)}
              style={{
                padding: '8px 16px',
                border: 'none',
                background: 'none',
                outline: 'none',
                cursor: 'pointer',
                fontSize: 14,
                fontWeight: active ? 600 : 400,
                color: active ? '#1976d2' : '#666',
                borderBottom: active ? '2px solid #1976d2' : '2px solid transparent',
                marginBottom: -1,
              }}
            >
              {t.label}
            </button>
          );
        })}
      </div>

      {loading && <p>Cargando conversaciones…</p>}
      {error && <p style={{ color: 'red' }}>Error: {error}</p>}
      {!loading && !error && conversaciones.length === 0 && <p>Sin conversaciones aún.</p>}

      {!loading && !error && (
        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
          {conversaciones.map((c) => (
            <li
              key={c.id}
              onClick={() => navigate(`/conversaciones/${c.id}`)}
              style={{
                padding: '12px 16px',
                marginBottom: 8,
                border: '1px solid #e0e0e0',
                borderRadius: 8,
                cursor: 'pointer',
                background: '#fafafa',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <div>
                <strong>{c.contact_address}</strong>
                <span style={{ marginLeft: 8, color: '#888', fontSize: 13 }}>
                  {CANAL_LABEL[c.canal] ?? c.canal}
                </span>
              </div>
              <div style={{ fontSize: 12, color: '#aaa' }}>
                {new Date(c.last_message_at).toLocaleString('es-CL')}
                <span
                  style={{
                    marginLeft: 8,
                    padding: '2px 6px',
                    borderRadius: 4,
                    background: c.status === 'open' ? '#e8f5e9' : '#f5f5f5',
                    color: c.status === 'open' ? '#2e7d32' : '#757575',
                    fontSize: 11,
                  }}
                >
                  {c.status}
                </span>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
